/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-07 15:26:55
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FullscreenBar, Layout, Heading, Page } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import PlansReview from 'src/components/views/subscription-v3/plans-review';
import AddonQA from 'src/components/views/subscription-v3/addon-qa';
import AddonCard from 'src/components/views/subscription-v3/addon/addon-card';
import { routes } from 'src/routes';
import { buildListAddon, checkUsingVariantForFree } from 'src/helpers/subscription-v3-helper';
import {
  exitSABFullscreen,
  enterSABFullscreen
} from 'src/integrations/shopify-app-bridge/fullscreen';
import * as subscriptionV3Actions from 'src/stores/actions/subscription-v3-actions';

class PlanAddon extends Component<WithI18nProps> {
  unsubscribeExit = undefined;

  state = {
    addonList: []
  };

  componentDidMount() {
    const { getDetailInvoice, invoice } = this.props;
    this.props.getAddons();

    // Get detail invoice
    if (_.isEmpty(invoice) || !invoice) {
      getDetailInvoice();
    }
    // Active fullscreen
    this.unsubscribeExit = enterSABFullscreen(this.handleBack);
  }
  componentWillReceiveProps(nextProps) {
    const { loading: prevLoading = false } = this.props;
    const {
      loading = false,
      allAddon = {},
      getAddonSuccess = false,
      subscription,
      tenantApp
    } = nextProps;
    const { status } = subscription;
    if (prevLoading === true && loading === false && getAddonSuccess === true) {
      const useFreeVariant = checkUsingVariantForFree(tenantApp);
      const addonList = buildListAddon(allAddon, status, useFreeVariant);
      this.setState({ addonList });
    }
  }

  componentWillUnmount() {
    this.unsubscribeExit();
  }

  render() {
    const { addonList } = this.state;
    const { i18n, location } = this.props;

    // Get addon per row
    const addonPerRow = [];
    for (let i = 0; i < addonList.length; i++) {
      const rowIndex = Math.floor(i / 3);
      if (!addonPerRow[rowIndex]) addonPerRow[rowIndex] = [];
      addonPerRow[rowIndex].push(addonList[i]);
    }

    const addOnSelected = _.get(location, 'state.addOnName', '');
    const analyticDays = _.get(location, 'state.analyticDays', '');

    return (
      <div className="BC-Page BC-Page__SubscriptionV3-Addon">
        <FullscreenBar onAction={this.handleBack}>
          <div>{i18n.translate('AdminHTML.SubscriptionV3.Addons.pageHeader')}</div>
        </FullscreenBar>
        <div>
          <div className="align-center card-title-uppercase">
            <Heading>{i18n.translate('AdminHTML.SubscriptionV3.Addons.pageTitle')}</Heading>
            <p>{i18n.translate('AdminHTML.SubscriptionV3.Addons.subContent')}</p>
          </div>
        </div>
        {addonPerRow.map((e, index) => {
          return (
            <div className="addons-list" key={index}>
              {e.map(addon => (
                <AddonCard
                  key={addon.name}
                  addon={addon}
                  handleAfterSubscribeAddon={this.handleAfterSubscribeAddon}
                  selected={addon.name === addOnSelected}
                  analyticDays={analyticDays}
                />
              ))}
            </div>
          );
        })}
        <Page>
          <Layout>
            <Layout.Section>
              <PlansReview />
            </Layout.Section>

            <Layout.Section>
              <AddonQA />
            </Layout.Section>
          </Layout>
        </Page>
      </div>
    );
  }

  // Handle back to subscription page
  handleBack = () => {
    const { history } = this.props;
    history.push(routes.subscription.plan());
    exitSABFullscreen();
  };

  handleAfterSubscribeAddon = () => {
    this.props.getAddons();
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  getDetailInvoice: () => dispatch(subscriptionV3Actions.getDetailInvoice(ownProps.i18n)),
  getAddons: () => dispatch(subscriptionV3Actions.getAddons(ownProps.i18n))
});

const mapStateToProps = (state, props) => {
  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  const tenantId = _.get(state.oauth, 'tenantApp.tenantId', {});
  const externalInfo = _.get(tenantApp, 'externalInfo', {});

  return {
    invoice: _.get(state.subscriptionV3, 'invoice', {}),
    subscription: _.get(state.oauth, 'subscription', {}),
    allAddon: _.get(state.subscriptionV3, 'addons', {}),
    loading: _.get(state.subscriptionV3, 'loading', false),
    getAddonSuccess: _.get(state.subscriptionV3, 'getAddonSuccess', false),
    tenantId,
    planName: _.get(externalInfo, 'plan_name', ''),
    tenantApp
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(PlanAddon));
